// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { PencilSquareIcon,TrashIcon, UserIcon } from '@heroicons/react/24/outline'
import { useNavigate } from 'react-router-dom'
import { useGetUsersQuery,useDeleteUserMutation } from './usersApiSlice'
import { memo,useState,useEffect } from 'react'

import UserModal from "./UserModal"
import EditUserForm from "./EditUserForm"   //POSle mozda

import { useSelector,useDispatch } from 'react-redux'
import { selectPositions,removePosition } from "./userPositionDataSlice"


const UserPozicija = ({ pozicijaId }) => {

    //Modal
    // const [pozicijaId, setpozicijaId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const navigate = useNavigate();
    const positions = useSelector(selectPositions);
    const dispatch = useDispatch()
    // console.log(positions)

    const [deleteUser, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteUserMutation();

    
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    //MOdal edit
    const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);

    //Server error
    useEffect(()=> {
        if(isDelError){
            alert(delerror.data.message);
        }
    })

    const handleConfirm = async () => {
        // await deleteUser({ id: user.id })
        // closeModal();
    };

        //ZA edit zaposlenog
    const handleOpenModalEdit = () => {
        setIsModalOpenEdit(true);
        // setpozicijaId(pozicijaId);
        //i da poslajem user id da bi nasao objekat iz kesha koji ce da modifikuje
    };

    const handleCloseModalEdit = () => {
        setIsModalOpenEdit(false);
    };

    const handleFormSubmitEdit = () => {
        handleCloseModalEdit();
    };

    //BRISE SVE REDOVE SA AKO IM JE ISTA ORGANIZACIJA ZATO STO IM JE ISTI ID!
    //AKO ZELIS DA PROMENIS OND AGA MORAS VEZATI OVDE SA NEKIM NOVIM ID SAMO U MEMORIJI
    const deletePozicija = (pozicijaId) => {
        dispatch(removePosition({ pozicijaId }))
    }

    if (positions) {

        console.log("POS:",positions[pozicijaId])
        
        return (
            <>
            <tr key={pozicijaId}>
                <td className="whitespace-nowrap border-r py-1 pl-4 pr-3 text-sm font-medium text-gray-900">{positions[pozicijaId].name}</td>
                <td className="whitespace-nowrap border-r px-3 py-1 text-sm text-gray-500">{positions[pozicijaId].pozicija.pozcicijaName}</td>
                <td className="whitespace-nowrap border-r px-3 py-1 text-sm text-gray-500">{positions[pozicijaId].sektor.sektorName}</td>
                {/* <td className="whitespace-nowrap border-r px-3 py-4 text-sm text-gray-500">{userRolesString}</td>
                <td className="whitespace-nowrap border-r px-3 py-4 text-sm text-gray-500">{userRolesString}</td>
                <td className="whitespace-nowrap border-r px-3 py-4 text-sm text-gray-500">{userRolesString}</td> */}
                {/* Ikonice skroz levo sa padingom*/}
                <td className="flex justify-begin relative whitespace-nowrap px-3 py-1 text-sm font-medium sm:pr-6">
                    {/* Kasnije edit */}
                    {/* <button href="#" onClick={handleOpenModalEdit} className="mr-1 text-blue-600 hover:text-blue-900">
                        <PencilSquareIcon className="h-5 w-5 shrink-0 stroke-yellow-600" aria-hidden="true"/>
                    </button> */}
                    <button href="#" onClick={()=>deletePozicija(positions[pozicijaId]._id)} className="px-1 py-1 text-blue-600 hover:text-blue-900">
                        <TrashIcon className="h-5 w-5 shrink-0 stroke-red-600" aria-hidden="true"/>
                    </button>
                </td>
            </tr>

            <UserModal isOpen={isModalOpenEdit} onClose={handleCloseModalEdit}>
                <EditUserForm onSubmit={handleFormSubmitEdit} onClose={handleCloseModalEdit} pozicijaId={pozicijaId}/>
            </UserModal>

            {isModalOpen && (
                <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
                    <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                        <div className="mt-3 text-center">
                            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                                <svg className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                            <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">Upoznorenje</h3>
                            <div className="mt-2 px-7 py-3">
                                <p className="text-sm text-gray-500">Da li ste sigurni da želite izbrisati odbaranog korisnika</p>
                            </div>
                            <div className="items-center px-4 py-3">
                                <button onClick={handleConfirm} className="px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300">Da</button>
                                <button onClick={closeModal} className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300">Ne</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            </>
        )

    } else return null
}

const memoizedUserPozicija = memo(UserPozicija)

export default memoizedUserPozicija

// Ikonice ravnomerno rasporednjene 
{/* <td className="flex justify-between relative whitespace-nowrap p-4 text-sm font-medium sm:pr-6">
    <button href="#" onClick={handleEdit} className="text-blue-600 hover:text-blue-900">
        <PencilSquareIcon className="h-5 w-5 shrink-0" aria-hidden="true"/>
    </button>
    <button href="#" onClick={handleEdit} className="text-blue-600 hover:text-blue-900">
        <PencilSquareIcon className="h-5 w-5 shrink-0" aria-hidden="true"/>
    </button>
    <button href="#" onClick={openModal} className="text-blue-600 hover:text-blue-900">
        <TrashIcon className="h-5 w-5 shrink-0 stroke-red-600" aria-hidden="true"/>
    </button>
</td> */}